import provideLayout from 'layout';
import AuthLayout from './AuthLayout';

export default provideLayout(AuthLayout);
